import I18nFileProvider from 'i18n/components/I18nFileProvider'
import { getI18nFileCodes } from 'i18n/helpers'
import React from 'react'
import { i18nSwitch } from 'services/featureToggler'
import { SUPPORTED_GEOAREAS } from 'services/geo-management'

const i18nFileCodes = getI18nFileCodes(...SUPPORTED_GEOAREAS)

export const I18nBeComponent: React.FC = () =>
  i18nSwitch(
    <I18nFileProvider platformCode="be" requiredFiles={i18nFileCodes} />,
    <img
      src="https://i.ytimg.com/vi/goouDxG9lUg/hqdefault.jpg"
      style={{ width: '50%', margin: 'auto' }}
      alt="goat"
    />
  )

export const I18nFeComponent: React.FC = () =>
  i18nSwitch(
    <I18nFileProvider platformCode="fe" requiredFiles={i18nFileCodes} />,
    <img
      src="https://cdn.vox-cdn.com/uploads/chorus_asset/file/2664638/Goat.1351089485.jpg"
      style={{ width: '50%', margin: 'auto' }}
      alt="scampa"
    />
  )
